module.exports = __webpack_public_path__ + "assets/meteor.2b65a6f7.svg";